import React from 'react';
import { field } from '../../../types/Field';
import { Form } from 'react-bootstrap';

interface Props {
    field: field;
    currentValue: string;
    setCurrentValue: Function;
}

function isNumber(n: any) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

const VariableSearchField: React.FC<Props> = (props) => {
    const onChange = (e: any) => {
        props.setCurrentValue(props.field.abbreviation, e.target.value);
    };

    return (
        <>
            <div
                id={props.field.abbreviation}
                className='col min-half blockvisible row-pad variableFieldContainer'
            >
                <label className='labelWhiteSpace'>{props.field.description}</label>
                <div className='col'>
                    <Form.Control
                        type='input'
                        className='o-form-input-name-password o-form-control okta-form-input-field input-fix'
                        required
                        size='sm'
                        name={props.field.abbreviation}
                        value={props.currentValue}
                        onChange={(e) => onChange(e)}
                    />
                </div>
            </div>
        </>
    );
};

export default VariableSearchField;
